import React, { useState, useEffect } from 'react'

import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import ReactTooltip from 'react-tooltip'
import moment from 'moment'
import LoadingSpinner from '../../components/common/spinner/LoadingSpinner'
import MessageFeedback from '../../components/common/messageFeedback/MessageFeedback'
import { DateMapper } from '../../components/common/dateMapper/DateMapper'
import EmptyState from '../../components/common/emptyState/EmptyState'
import Icon from '../../components/common/icon/Icon'
import SelectedRecipientsModal from '../../components/common/selectedRecipientsModal/SelectedRecipientsModal'
import ElementSelected from '../../components/common/elementSelected/ElementSelected'
import ModalWrapper from '../../components/common/modal/ModalWrapper'
import SingleLoader from '../../components/common/singleLoader/SingleLoader'
import InputContainer from '../../components/common/inputContainer/InputContainer'
import MessageNoResult from '../../components/common/messageNoResult/MessageNoResult'
import Button from '../../components/common/button/Button'
import DataTable from '../../components/common/dataTable/DataTable'
import DataTableHeader from '../../components/common/dataTable/DataTableHeader'
import DataTableRow from '../../components/common/dataTable/DataTableRow'
import DataTableCol from '../../components/common/dataTable/DataTableCol'
import DataTableHeaderCol from '../../components/common/dataTable/DataTableHeaderCol'
import OrderGrid from '../../components/common/dataTable/OrderGrid'
import Pager from '../../components/common/pager/Pager'
import MessageBox from '../../components/common/messageBox/MessageBox'
import Tooltip from '../../components/common/tooltip/Tooltip'
import Personalization from '../../components/common/personalization/Personalization'

import { getEmailSendingDetails, getEmailSendings } from '../../api/beSendApi/BeSendApi'
import { getListDataById } from '../../api/beListApi/BeListApi'
import { getMessageDetails } from '../../api/beEmailMessageApi/BeEmailMessageApi'
import { getSendingTotalCounters, getSendingRecipientsTotalCounters } from '../../api/statisticsApi/StatisticsApi'
import { getGroupDetails, getRecipientEmail } from '../../api/beRecipientApi/BeRecipientApi'
import { getFilter } from '../../api/beFilterApi/BeFilterApi'
import { getAccountDataRetention } from '../../api/beAccount/BeAccount'

import batchPromises from '../../services/batchPromises'

const PAGE_STATUS_READY = 'PAGE_STATUS_READY'

const PAGE_STATUS_ERROR = 'PAGE_STATUS_ERROR'
const PAGE_STATUS_PARAMS_ERROR = 'PAGE_STATUS_PARAMS_ERROR'

const PAGE_STATUS_LOADING = 'PAGE_STATUS_LOADING'

const initialPageState = {
  pageStatus: PAGE_STATUS_LOADING,
  loadPage: true,
  statDeleted: true,
  includedGroupsLoading: true,
  appliedFiltersLoading: true,
  excludedGroupsLoading: true
}

const initialInfoSend = {
  IncludedGroups: [],
  AppliedFilters: [],
  ExcludedGroups: []
}

const initialRecipientsList = {
  data: [],
  loading: true,
  error: false,
  emptyState: false,
  noData: false,
  availableRecipients: null,
  pageNumber: 1,
  pageSize: 10,
  loadData: false,
  totalItems: null,
  orderBy: 'OrderbyLastOpening',
  orderDescending: true
}

const initialSearch = {
  email: '',
  groups: undefined,
  activity: ''
}

let timeZoneCode = ''
let retentionDays

// http://localhost:1234/frontend/sendreportdetails/listGuid/CACD7F73-2EFC-45CE-9600-913CC7D5CA99/idList/1/idNL/1432/idSend/73
// http://d4x9h.smtpnext.com/frontend/sendreportdetails/listGuid/CACD7F73-2EFC-45CE-9600-913CC7D5CA99/idList/1/idNL/1432/idSend/73
const SendReportDetails = ({ match, history, location, intl }) => {
  const listGuid = match.params.listGuid
  const idList = parseInt(match.params.idList)
  const idMessage = parseInt(match.params.idNL)
  const idSend = parseInt(match.params.idSend)

  const [pageState, setPageState] = useState(initialPageState)
  const [infoSend, setInfoSend] = useState(initialInfoSend)
  const [modalOpen, setModalOpen] = useState(false)
  const [recipientsList, setRecipientsList] = useState(initialRecipientsList)
  const [search, setSearch] = useState(initialSearch)
  const [recipientDaysAvailable, setRecipientDaysAvailable] = useState(null)

  function convertDateUtctoCTZ (dateString) {
    const dateInstance = new Date(dateString)
    // const tmp = new Date(dateInstance.getTime() + dateInstance.getTimezoneOffset() * 60000)
    // debugger
    return DateMapper.toLocalDate(dateInstance, timeZoneCode)
  }

  // on render
  useEffect(() => {
    ReactTooltip.rebuild()
  })

  //  on mount
  useEffect(() => {
    reloadPage()

    // on unmount
    return () => { ReactTooltip.rebuild() }
  }, [])

  useEffect(() => {
    if (pageState.loadPage) {
      setPageState((prevState) => ({ ...prevState, loadPage: false }))
      const search = {
        IdMessages: [idMessage]
      }
      getEmailSendings(idList, listGuid, search, 1, 1, false)
        .then((emailSendings) => {
          if (emailSendings.TotalItems > 0) {
            Promise.all([
              getMessageDetails(idList, listGuid, idMessage, false),
              getEmailSendingDetails(idList, listGuid, idSend),
              getListDataById(idList, listGuid),
              getSendingTotalCounters(idList, listGuid, idMessage, idSend, ['EI']),
              getAccountDataRetention(idList, listGuid)
            ]).then(([msgDett, sendingDetails, listData, recipients, accountDataRetention]) => {
              timeZoneCode = listData.TimeZoneCode

              getSendingRecipients()
              setInfoSend((prevState) => ({
                ...prevState,
                ListName: listData.Name,
                Subject: msgDett.Subject,
                Notes: msgDett.Notes,
                StartDate: (sendingDetails.StartDateJs) ? DateMapper.datetimeToSTring(convertDateUtctoCTZ(sendingDetails.StartDateJs)) : '-',
                Recipients: recipients.EI,
                IncludedGroups: sendingDetails.Groups ? sendingDetails.Groups.split(',').map(o => { return { id: o } }) : [],
                AppliedFilters: sendingDetails.Filtri ? sendingDetails.Filtri.split(',').map(o => { return { id: o } }) : [],
                ExcludedGroups: sendingDetails.ExcludeGroups ? sendingDetails.ExcludeGroups.split(',').map(o => { return { id: o } }) : [],
                SenderName: sendingDetails.SenderName,
                SenderEmail: sendingDetails.SenderEmail,
                ReplyToEmail: sendingDetails.ReplyToEmail

              }))

              retentionDays = (accountDataRetention > 365) ? 365 : accountDataRetention
              if (sendingDetails.StartDateJs) {
                const diffTime = Math.abs(moment.utc() - convertDateUtctoCTZ(sendingDetails.StartDateJs))
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
                setRecipientDaysAvailable(retentionDays - diffDays)
              } else {
                setRecipientDaysAvailable('-')
              }

              setPageState((prevState) => ({ ...prevState, pageStatus: PAGE_STATUS_READY, statDeleted: false }))

              if (sendingDetails.Groups) {
                const ids = sendingDetails.Groups.split(',')
                batchPromises(ids, 10, getIncludedGroups).then((batchResult) => {
                  setPageState((prevState) => ({ ...prevState, includedGroupsLoading: false }))
                })
              } else { setPageState((prevState) => ({ ...prevState, includedGroupsLoading: false })) }
              if (sendingDetails.ExcludeGroups) {
                const ids = sendingDetails.ExcludeGroups.split(',')
                batchPromises(ids, 10, getExcludedGroups).then((batchResult) => {
                  setPageState((prevState) => ({ ...prevState, excludedGroupsLoading: false }))
                })
              } else { setPageState((prevState) => ({ ...prevState, excludedGroupsLoading: false })) }
              if (sendingDetails.Filtri) {
                const ids = sendingDetails.Filtri.split(',')
                batchPromises(ids, 10, getAppliedFilters).then((batchResult) => {
                  setPageState((prevState) => ({ ...prevState, appliedFiltersLoading: false }))
                })
              } else { setPageState((prevState) => ({ ...prevState, appliedFiltersLoading: false })) }
            }).catch(() => {
              setPageState((prevState) => ({ ...prevState, statDeleted: false, pageStatus: PAGE_STATUS_ERROR }))
            })
          } else {
            setPageState((prevState) => ({ ...prevState, statDeleted: true, pageStatus: PAGE_STATUS_READY }))
          }
        })
        .catch(() => {
          setPageState((prevState) => ({ ...prevState, statDeleted: false, pageStatus: PAGE_STATUS_ERROR }))
        })

      getSendingRecipientsTotalCounters(idList, listGuid, idMessage, idSend, 0, 1, '', null, null, '', '', false)
        .then((availableRecipients) => {
          setRecipientsList((prevState) => ({ ...prevState, availableRecipients: availableRecipients.TotalItems }))
        })
        .catch(() => {
          setRecipientsList((prevState) => ({ ...prevState, availableRecipients: 'error' }))
        })

      // setPageState((prevState) => ({ ...prevState, pageStatus: PAGE_STATUS_READY }))
    }
  }, [pageState.loadPage])

  useEffect(() => {
    if (recipientsList.loadData) {
      getSendingRecipients()
    }
  }, [recipientsList.loadData])

  function getSendingRecipients () {
    setRecipientsList((prevState) => ({ ...prevState, loading: true }))
    getSendingRecipientsTotalCounters(idList, listGuid, idMessage, idSend, recipientsList.pageSize, recipientsList.pageNumber, search.email, null, null, '',
      recipientsList.orderBy, recipientsList.orderDescending)
      .then((res) => {
        setRecipientsList((prevState) => ({ ...prevState, totalItems: res.TotalItems, loading: false }))

        if (res.TotalItems === 0) {
          if (JSON.stringify(search) === JSON.stringify(initialSearch)) {
            setRecipientsList((prevState) => ({ ...prevState, emptyState: true, noData: false, loadData: false }))
          } else {
            setRecipientsList((prevState) => ({ ...prevState, emptyState: false, noData: true, loadData: false }))
          }
        } else {
          const resData = res.RecipientCounters.map((o) => ({
            ...o,
            OpeningStats: {
              ...o.OpeningStats,
              // LastActionDate: o.OpeningStats.LastActionDateJs ? DateMapper.datetimeToSTring(convertDateUtctoCTZ(o.OpeningStats.LastActionDateJs)) : '-'
              LastActionDate: convertLastActionDate(o.OpeningStats.LastActionDateJs)
            }
          }))

          setRecipientsList((prevState) => ({ ...prevState, emptyState: false, noData: false, loadData: false, data: resData }))

          const idRecipients = resData.map((rec) => rec.IdRecipient)
          batchPromises(idRecipients, 10, getRecipientInfo).then((batchResult) => {})
        }
      })
      .catch(() => {
        setRecipientsList((prevState) => ({ ...prevState, error: true, loading: false }))
      })
  }

  function convertLastActionDate (date) {
    console.log(date)
    if (date) {
      const dateCtz = convertDateUtctoCTZ(date)
      const dateCtzStr = DateMapper.datetimeToSTring(dateCtz)
      return dateCtzStr
    } else {
      return '-'
    }
  }

  function getIncludedGroups (idGroup) {
    return getGroupDetails(idList, listGuid, parseInt(idGroup))
      .then((resp) => {
        setInfoSend((prevState) => ({
          ...prevState,
          IncludedGroups: prevState.IncludedGroups.map((o) => ((parseInt(o.id) === parseInt(idGroup)) ? { ...o, text: resp.Name } : o))
        }
        ))
        return idGroup
      })
      .catch(() => {
        setInfoSend((prevState) => ({
          ...prevState,
          IncludedGroups: prevState.IncludedGroups.map((o) => ((parseInt(o.id) === parseInt(idGroup)) ? { ...o, text: <Icon family='fa' icon='exclamation-triangle' className='text-light' /> } : o))
        }
        ))
        return idGroup
      })
  }

  function getExcludedGroups (idGroup) {
    return getGroupDetails(idList, listGuid, parseInt(idGroup))
      .then((resp) => {
        setInfoSend((prevState) => ({
          ...prevState,
          ExcludedGroups: prevState.ExcludedGroups.map((o) => ((parseInt(o.id) === parseInt(idGroup)) ? { ...o, text: resp.Name } : o))
        }
        ))
        return idGroup
      })
      .catch(() => {
        setInfoSend((prevState) => ({
          ...prevState,
          ExcludedGroups: prevState.ExcludedGroups.map((o) => ((parseInt(o.id) === parseInt(idGroup)) ? { ...o, text: <Icon family='fa' icon='exclamation-triangle' className='text-light' /> } : o))
        }
        ))
        return idGroup
      })
  }

  function getAppliedFilters (idFilter) {
    return getFilter(idList, listGuid, parseInt(idFilter))
      .then((resp) => {
        setInfoSend((prevState) => ({
          ...prevState,
          AppliedFilters: prevState.AppliedFilters.map((o) => ((parseInt(o.id) === parseInt(idFilter)) ? { ...o, text: resp.Name } : o))
        }
        ))
        return idFilter
      })
      .catch(() => {
        setInfoSend((prevState) => ({
          ...prevState,
          AppliedFilters: prevState.AppliedFilters.map((o) => ((parseInt(o.id) === parseInt(idFilter)) ? { ...o, text: <Icon family='fa' icon='exclamation-triangle' className='text-light' /> } : o))
        }
        ))
        return idFilter
      })
  }

  function getRecipientInfo (idRecipient) {
    if (idRecipient) {
      return getRecipientEmail(idList, listGuid, idRecipient)
        .then((resp) => {
          setRecipientsList((prevState) => ({
            ...prevState,
            data: prevState.data.map((o) => ((o.IdRecipient === idRecipient) ? { ...o, Email: resp } : o))
          }))
          return idRecipient
        })
        .catch(() => {
          setRecipientsList((prevState) => (
            {
              ...prevState,
              data: prevState.data.map((o) => ((o.IdRecipient === idRecipient) ? { ...o, Email: <Icon family='fa' icon='exclamation-triangle' className='text-light' /> } : o))
            }))
          return idRecipient
        })
    } else {
      const noTrackedRecipient = (<em>{intl.formatMessage({ id: 'Load.Statistics.NoTrackedRecipient' })}</em>)
      setRecipientsList((prevState) => (
        {
          ...prevState,
          data: prevState.data.map((o) => ((o.IdRecipient === idRecipient) ? { ...o, Email: noTrackedRecipient } : o))
        }))
      // return idRecipient
      return idRecipient
    }
  }

  function reloadPage () {
    setPageState((prevState) => ({ ...initialPageState, loadPage: true, PAGE_STATUS_LOADING }))
  }

  const personalizationProps = {
    idList: idList,
    showLogo: true,
    applyCustomCSS: true
  }

  const propStatDelted = {
    title: intl.formatMessage({ id: 'Load.Statistics.DeletingStatsTitle' }),
    description: intl.formatMessage({ id: 'Load.Statistics.DeletingStatsDescription' })
  }

  const propsSelectedRecipientsModal = {
    includedGroups: infoSend.IncludedGroups,
    excludedGroups: infoSend.ExcludedGroups,
    appliedFilters: infoSend.AppliedFilters,
    closeCallback: closeModal,
    selectedItem: infoSend.IncludedGroups.length > 1 ? 'IncludedGroups' : infoSend.ExcludedGroups.length > 1 ? 'ExcludedGroups' : 'AppliedFilters'

  }

  const propsInputSearch = {
    value: search.email,
    type: 'text',
    placeholder: intl.formatMessage({ id: 'Load.Statistics.RecipientListSearchPlaceholder' }),
    onChange: onChangeInputSearch,
    enablePressEnter: true,
    pressEnterCallback: onClickSearch,
    className: 'test-statReportDettPubb-searchEmail'
  }

  const propsBtnCancel = {
    children: intl.formatMessage({ id: 'Load.MailupCommon.Cancel' }),
    kind: 'secondary',
    onClick: onClickResetSearch,
    className: 'test-statReportDettPubb-resetSerach frontend-m-right-thin'
  }

  const propsBtnSearch = {
    children: intl.formatMessage({ id: 'Load.MailupCommon.SearchButton' }),
    kind: 'secondary',
    onClick: onClickSearch,
    className: 'test-statReportDettPubb-clicSerach'
  }

  const propsMessageNoResult = {
    text: intl.formatMessage({ id: 'Load.Common.NoData' })
  }

  const propsPager = {
    currentPage: recipientsList.pageNumber,
    itemsPerPage: recipientsList.pageSize,
    totalItems: recipientsList.totalItems,
    onChange: onChangePager,
    ofLabel: intl.formatMessage({ id: 'Load.Pager.Of' }),
    itemsLabel: intl.formatMessage({ id: 'Load.Pager.Items' }),
    className: 'test-statReportDettPubb-paging'
  }

  function onChangePager (val) {
    setRecipientsList((prevState) => ({ ...prevState, pageNumber: val.pageNumber, pageSize: val.pageSize, loadData: true }))
  }

  function onChangeInputSearch (e) {
    setSearch({ ...search, email: e.target.value })
  }

  function onClickSearch () {
    setRecipientsList((prevState) => ({ ...prevState, pageNumber: 1, loadData: true }))
  }

  function onClickResetSearch () {
    setSearch(initialSearch)
    setRecipientsList((prevState) => ({ ...initialRecipientsList, loadData: true, availableRecipients: recipientsList.availableRecipients }))
  }

  function setOrder (v) {
    setRecipientsList((prevState) => ({ ...prevState, orderBy: v, orderDescending: !prevState.orderDescending, loadData: true }))
  }

  // on update messages details

  return (
    <>
      <Tooltip />
      <div className='frontend-wrapper-xl'>
        {(pageState.pageStatus === PAGE_STATUS_LOADING) &&
          <LoadingSpinner />}

        {(pageState.pageStatus === PAGE_STATUS_PARAMS_ERROR) &&
          <MessageFeedback kind='error'>{intl.formatMessage({ id: 'Load.Statistics.ErrorDisplayingReport' })}</MessageFeedback>}

        {(pageState.pageStatus === PAGE_STATUS_ERROR) &&
          <MessageFeedback kind='error'>
            {intl.formatMessage({ id: 'Load.Statistics.ErrorLoadingData' })}
            <a className='frontend-p-left-xs-thin' onClick={reloadPage}>{intl.formatMessage({ id: 'Load.MailupCommon.ReloadData' })}</a>
          </MessageFeedback>}

        {(pageState.pageStatus === PAGE_STATUS_READY) && <>
          {pageState.statDeleted === true
            ? <EmptyState {...propStatDelted} />
            : <>
              <Personalization {...personalizationProps} />
              <Tooltip />
              <div className='frontend-row frontend-row_reset row-flex'>
                <h1><b>{intl.formatMessage({ id: 'Load.SendReportDettFrontend.Title' })}</b></h1>
              </div>

              <div className='frontend-row frontend-row_reset'>
                <div className='col-xs-8 frontend-p-left-0'>
                  <div className='frontend-box frontend-p-bottom test-sendReportDettPubb-MsgDett'>
                    <h3 className='frontend-m-bottom-x-sm'><b>{intl.formatMessage({ id: 'Load.Statistics.MsgDett' })}</b></h3>
                    <p className='frontend-m-bottom-xx-sm'><strong>{infoSend.Subject}</strong></p>
                    <p className='frontend-m-bottom-x-sm'>{infoSend.Notes}</p>
                    <p className='frontend-m-bottom-x-sm'>
                      <b>{intl.formatMessage({ id: 'Load.MailupCommon.List' })}:</b>&nbsp;
                      <span>{idList} - {infoSend.ListName}</span>
                    </p>
                    <p className='frontend-m-bottom-xx-sm'>
                      <b>{intl.formatMessage({ id: 'Load.Statistics.DateSend' })}:</b>&nbsp;
                      <span>{infoSend.StartDate} {timeZoneCode.split(':')[0]}</span>
                    </p>

                  </div>
                </div>
                <div className='col-xs-4 frontend-p-right-0'>
                  <div className='frontend-box frontend-p-bottom test-sendReportDettPubb-Recipients'>
                    <h2><b>{intl.formatNumber(infoSend.Recipients)}</b></h2>
                    <p className='frontend-text-uppercase frontend-note'>{intl.formatMessage({ id: 'Load.Statistics.SelectedRecipients' })}</p>
                  </div>

                </div>
              </div>

              <div className='frontend-row frontend-row_reset'>
                <div className='col-xs-8 frontend-p-left-0'>
                  <div className='frontend-box frontend-p-bottom-thin test-sendReportDettPubb-SelectedRecipients'>
                    <h3 className='frontend-m-bottom-x-sm'><b>{intl.formatMessage({ id: 'Load.Statistics.SelectedRecipients' })}</b></h3>
                    {(!pageState.includedGroupsLoading && !pageState.excludedGroupsLoading && !pageState.appliedFiltersLoading) &&
                      <div className=''>
                        {infoSend.IncludedGroups.length === 0 && infoSend.ExcludedGroups.length === 0 && infoSend.AppliedFilters.length === 0 &&
                          <em className='frontend-p-bottom-thin'>{intl.formatMessage({ id: 'Load.Common.RecipientSelectNoData' })}</em>}
                        {(infoSend.IncludedGroups.length > 0 || infoSend.ExcludedGroups.length > 0 || infoSend.AppliedFilters.length > 0) && <>
                          <SelectedRecipients title='IncludedGroups' items={infoSend.IncludedGroups} />
                          <SelectedRecipients title='ExcludedGroups' items={infoSend.ExcludedGroups} />
                          <SelectedRecipients title='AppliedFilters' items={infoSend.AppliedFilters} />
                                                                                                                                             </>}
                      </div>}
                    {(pageState.includedGroupsLoading || pageState.excludedGroupsLoading || pageState.appliedFiltersLoading) && <SingleLoader height='250px' />}

                  </div>
                </div>

                <div className='col-xs-4 frontend-p-right-0'>
                  <div className='frontend-box frontend-p-bottom test-sendReportDettPubb-SendInfomation'>
                    <h3 className='frontend-m-bottom-x-sm'><b>{intl.formatMessage({ id: 'Load.Statistics.SendInfomation' })}</b></h3>

                    <ul className=''>
                      <li className='frontend-m-bottom-x-sm'>
                        <p><b className='text-strong'>{intl.formatMessage({ id: 'Load.Common.SenderNameLabel' })}</b></p>
                        <span>{infoSend.SenderName || '-'}</span>
                      </li>
                      <li className='frontend-m-bottom-x-sm'>
                        <p><b className='text-strong'>{intl.formatMessage({ id: 'Load.MailupCommon.SenderEmail' })}</b></p>
                        <span>{infoSend.SenderEmail || '-'}</span>
                      </li>
                      <li>
                        <p><b className='text-strong'>{intl.formatMessage({ id: 'Load.Common.ReplyToEmailLabel' })}</b></p>
                        <span>{infoSend.ReplyToEmail || '-'}</span>
                      </li>
                    </ul>

                  </div>
                </div>
              </div>

              {recipientsList.error ? <div className='frontend-row frontend-row-reset frontend-m-bottom text-center'>

                <div className='frontend-box frontend-p-bottom'>
                  <p>
                    <h3 className='frontend-m-bottom-x-sm'>
                      <b>{intl.formatMessage({ id: 'Load.Common.ManageRecipients' })}</b>
                    </h3>
                  </p>
                  <Icon family='fa' icon='exclamation-triangle' className='text-light' />&nbsp;
                  <span>{intl.formatMessage({ id: 'Load.Common.LoadDataError' })}</span>
                </div>
              </div>
                : <>
                  {recipientsList.emptyState ? <>
                    <div className='frontend-box frontend-p-bottom frontend-m-bottom'>
                      <h2 className='text-center'>
                        <b>{intl.formatMessage({ id: 'Load.Common.SelectedRecipients' })}</b>
                      </h2>
                      <div className='frontend-p-top'>
                        <p className='text-center'>
                          <em>
                            {intl.formatMessage({ id: 'Load.Common.NoDataAvailable' })}

                          </em>
                        </p>
                      </div>
                    </div>
                  </>
                    : <>
                      <div className='frontend-row-reset frontend-p-bottom-xs-thin'>
                        <h2 className='d-inline-block'>
                          <span>{intl.formatMessage({ id: 'Load.Statistics.RecipientStats' })}</span>
                      &nbsp;
                          <b className=''>
                            {recipientsList.availableRecipients != null
                              ? recipientsList.availableRecipients === 'error'
                                ? <Icon family='fa' icon='exclamation-triangle' className='text-light' />
                                : intl.formatNumber(recipientsList.availableRecipients)
                              : <span className='is-loading' />}
                          </b>&nbsp;
                          {intl.formatMessage({ id: 'Load.Statistics.RecipientStatsRecipients' })}
                        </h2>
                        <Icon family='sli' icon='question' className='note frontend-p-left-xs-thin' tooltipText={intl.formatMessage({ id: 'Load.Statistics.RecipientsRetentionTooltip' })} />
                      </div>
                      <div className='frontend-row frontend-row-reset frontend-p-bottom'>
                        {/* <pre>{JSON.stringify(groupsChosen.options)}</pre> */}
                        <div className='col-xs-9 frontend-p-left-0'>
                          <InputContainer {...propsInputSearch} />
                        </div>

                        <div className='col-xs-3 frontend-p-right-0 frontend-text-right'>
                          <Button {...propsBtnCancel} />
                          <Button {...propsBtnSearch} />
                        </div>
                        {/* <div className='col-xs-1 frontend-p-right-0' /> */}
                      </div>
                      <div className='frontend-row frontend-row-reset frontend-m-bottom'>

                        <div className='frontend-box'>
                          {recipientsList.loading ? <SingleLoader height='465px' />
                            : <>
                              <div className='frontend-row-reset frontend-p-bottom-xs-thin'>
                                <h3 className='d-inline-block'>
                                  <span className=''>{intl.formatMessage({ id: 'Load.Common.SearchResults' })}</span>
                                  <b className=''> {intl.formatNumber(recipientsList.totalItems)}</b>
                                  <span className='' />

                                </h3>
                                /
                                {recipientsList.availableRecipients != null
                                  ? recipientsList.availableRecipients === 'error'
                                    ? <Icon family='fa' icon='exclamation-triangle' className='text-light' />

                                    : intl.formatNumber(recipientsList.availableRecipients)
                                  : <span className='is-loading' />}
                                <Icon family='sli' icon='question' className='note frontend-p-left-xs-thin' tooltipText={intl.formatMessage({ id: 'Load.Statistics.RecipientsRetentionTooltip' })} />

                              </div>
                              {(recipientsList.noData)
                                ? <MessageNoResult className='frontend-m-bottom frontend-m-top-x-sm' {...propsMessageNoResult} />
                                : <>
                                  <DataTable>
                                    <DataTableHeader>

                                      <DataTableHeaderCol width='5'>
                                        {intl.formatMessage({ id: 'Load.Statistics.Recipient' })}
                                      </DataTableHeaderCol>
                                      <DataTableHeaderCol width='3' className='frontend-text-right'>
                                        {intl.formatMessage({ id: 'Load.Statistics.LastOpeningDate' })}&nbsp;
                                        <OrderGrid data='OrderbyLastOpening' callback={setOrder} isActive={recipientsList.orderBy === 'OrderbyLastOpening'} className='test-sendReportDettPubb-OrderbyLastOpening' />

                                      </DataTableHeaderCol>
                                      <DataTableHeaderCol width='2' className='frontend-text-right'>
                                        {intl.formatMessage({ id: 'Load.Statistics.TotalOpenings' })}&nbsp;
                                        <OrderGrid data='OrderbyAT' callback={setOrder} isActive={recipientsList.orderBy === 'OrderbyAT'} className='test-sendReportDettPubb-OrderbyLastOpening' />

                                      </DataTableHeaderCol>
                                      <DataTableHeaderCol width='2' className='frontend-text-right'>
                                        {intl.formatMessage({ id: 'Load.Common.TotalClicks' })}&nbsp;
                                        <OrderGrid data='OrderbyCT' callback={setOrder} isActive={recipientsList.orderBy === 'OrderbyCT'} className='test-sendReportDettPubb-OrderbyLastOpening' />

                                      </DataTableHeaderCol>
                                    </DataTableHeader>
                                    {recipientsList.data.map((item, index) =>
                                      <DataTableRow key={index}>

                                        <DataTableCol width='5'>
                                          {item.Email && <p>{item.Email}</p>}
                                          {!item.Email && <p className='is-loading' />}
                                        </DataTableCol>
                                        <DataTableCol width='3' className='frontend-text-right'>
                                          {item.OpeningStats.TotalCounter > 0 && <p>{item.OpeningStats.LastActionDate} {timeZoneCode.split(':')[0]}</p>}
                                          {item.OpeningStats.TotalCounter === 0 && <p>-</p>}
                                        </DataTableCol>
                                        <DataTableCol width='2' className='frontend-text-right'>  <p className='text-light'>{intl.formatNumber(item.OpeningStats.TotalCounter)}</p></DataTableCol>
                                        <DataTableCol width='2' className='frontend-text-right'> <p className='text-light'>{intl.formatNumber(item.ClickStats.TotalCounter)}</p></DataTableCol>

                                      </DataTableRow>
                                    )}
                                  </DataTable>
                                  <Pager {...propsPager} />
                                  </>}
                              </>}
                        </div>

                      </div>
                      </>}
                  </>}
              </>}

          <div className='frontend-row frontend-row_reset'>
            <div className='col-xs-12 frontend-p-left-0 frontend-p-right-0'>
              <MessageBox type='tip' className='m-bottom-0' title={intl.formatMessage({ id: 'Load.Statistics.TitleDataAvailability' }, { x: recipientDaysAvailable })}>
                {intl.formatMessage({ id: 'Load.Statistics.DescrDataAvailability' }, { x: retentionDays })}
              </MessageBox>
            </div>
          </div>

                                                         </>}
      </div>
      <ModalWrapper openModal={modalOpen} onClose={closeModal} closeOnOverlayClick>
        <SelectedRecipientsModal {...propsSelectedRecipientsModal} />
      </ModalWrapper>
    </>
  )

  function SelectedRecipients ({ title, items, limit = 8, className, isLink, linkCallback }) {
    if (!items || items.length === 0) {
      return (<></>)
    }
    const rest = items.length - limit
    const hasRest = rest > 0
    const onClick = openModal(title, items)

    return (
      <div className='frontend-row frontend-row_reset frontend-m-bottom-x-sm'>
        <p className='frontend-m-bottom-xx-sm'><b>{intl.formatMessage({ id: 'Load.Statistics.' + title })}</b></p>
        <ElementSelected className={className} items={items.slice(0, limit)} isLink={isLink} linkCallback={linkCallback}>
          {hasRest && <a className='frontend-link-secondary elemento-selezionato_link test-sendReportDettPubb-modalSelectedRecipients' onClick={onClick}>+{rest} {intl.formatMessage({ id: 'Load.Statistics.' + title })}</a>}
        </ElementSelected>
      </div>
    )
  }

  function openModal (title, items) {
    return event => {
      setModalOpen(true)
    }
  }

  function closeModal () {
    setModalOpen(false)
  }
}

export default injectIntl(withRouter(SendReportDetails))
